// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { COMMON_SET_UNREAD_MESSAGE } from './constants';

export function setUnreadMessage(data) {
  return {
    type: COMMON_SET_UNREAD_MESSAGE,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_UNREAD_MESSAGE:
      const users = state.filteredUserList.map(user => {
        if (user.cid === action.data) {
          const prevCount = user.unreads_count;
          return Object.assign(user, { unreads_count: prevCount + 1 });
        } else {
          return user;
        }
      });

      const newUsers = state.newUsers.map(user => {
        if (user.cid === action.data) {
          const prevCount = user.unreads_count;
          return Object.assign(user, { unreads_count: prevCount + 1 });
        } else {
          return user;
        }
      });

      const recentlyReassignedUsers = state.recentlyReassignedUsers.map(user => {
        if (user.cid === action.data) {
          const prevCount = user.unreads_count;
          return Object.assign(user, { unreads_count: prevCount + 1 });
        } else {
          return user;
        }
      });

      const groups = state.groups.map(group => {
        if (group.cid === action.data) {
          const prevCount = group.unreads_count;
          return Object.assign(group, { unreads_count: prevCount + 1 });
        } else {
          return group;
        }
      });

      return {
        ...state,
        filteredUserList: users,
        newUsers: newUsers,
        recentlyReassignedUsers: recentlyReassignedUsers,
        groups: groups,
        users: users,
        recentlyReassignedUsersChannels: recentlyReassignedUsers,
        newUsersChannels: newUsers,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setUnreadMessage.js